import { useState } from "react";
import { UploadCloud } from "lucide-react";

export function DropZone({ onFiles, accept, multiple = false, disabled = false, label, hint, icon: Icon = UploadCloud, className = "", testid = "dropzone" }) {
  const [over, setOver] = useState(false);
  const take = (list) => {
    const files = Array.from(list || []).filter((f) => !accept || accept.split(",").some((a) => { a = a.trim().toLowerCase(); return a.endsWith("/*") ? f.type.startsWith(a.slice(0, -1)) : f.name.toLowerCase().endsWith(a.replace("application/", ".").replace("image/", ".")) || f.type === a; }));
    if (files.length) onFiles(multiple ? files : files.slice(0, 1));
  };
  return (
    <label
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); if (!disabled) take(e.dataTransfer.files); }}
      className={`flex flex-col items-center justify-center gap-1 rounded-md border-2 border-dashed p-6 text-sm text-center cursor-pointer transition-colors ${over ? "border-blue-500 bg-blue-50 text-blue-800" : "border-slate-300 text-slate-600 hover:bg-slate-50"} ${disabled ? "opacity-60 cursor-not-allowed" : ""} ${className}`}
      data-testid={testid} data-dragover={over || undefined}>
      <Icon className={`h-6 w-6 ${over ? "text-blue-600" : "text-slate-400"}`} />
      <span>{over ? "Drop to upload" : label}</span>
      {hint && <span className="text-[11px] text-slate-500">{hint}</span>}
      <input type="file" className="hidden" accept={accept} multiple={multiple} disabled={disabled} onChange={(e) => { take(e.target.files); e.target.value = ""; }} data-testid={`${testid}-input`} />
    </label>
  );
}
